// The red or green edge of something incomplete or complete (#666): a class, so the colours stay Tailwind's (and Outdoor mode's).
export const completionEdgeColour = (complete: boolean) => (complete ? 'border-l-green-700' : 'border-l-red-700');
